/**
 * The stage per orientation, in stage px (the canvas buffer size). The
 * runtime re-exports it from `evaluateFrame`; the picture map reads it for
 * a stage-filling sprite (spec 026 D-27) without importing the runtime.
 */
import type { Orientation } from '../@types';

export const STAGE_SIZES: Readonly<Record<Orientation, { width: number; height: number }>> = Object.freeze({
  portrait: { width: 375, height: 667 },
  landscape: { width: 667, height: 375 },
  desktop: { width: 1280, height: 720 },
});
